export enum PaysafeSelectors {
  CardNumber = '#card-number',
  CardNumberInvalid = '#card-number.invalid',
  CardNumberValid = '#card-number.valid',
  Cvv = '#cvv',
  CvvInvalid = '#cvv.invalid',
  CvvValid = '#cvv.valid',
  ExpiryDate = '#expiry-date',
  ExpiryDateInvalid = '#expiry-date.invalid',
  ExpiryDateValid = '#expiry-date.valid',
  Input = 'input',
  InputInvalid = '.invalid',
  InputValid = '.valid',
}
